import { userService } from '../_services';
import { router } from '../_helpers';
import axios from 'axios';

const user = localStorage.getItem('user');
let initialState = user
  ? {
      status: {
        loggedIn: true,
        role: JSON.parse(user).role,
        trainings: JSON.parse(user).trainings
      }
    }
  : { status: {}, user: null, trainings: [] };

export const authentication = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ dispatch, commit }, { email, password, redirectUrl }) {
      commit('loginRequest', { email });
      userService.login(email, password).then(
        (user) => {
          axios
            .get(
              `${process.env.ROOT_API}/api/v1/users/${user.data.id}/trainings`,
              {
                headers: { Authorization: 'Bearer ' + user.data.token }
              }
            )
            .then((response) => {
              user.data.trainings = response.data;
              var path = '/';
              if (redirectUrl) {
                path = redirectUrl;
              }
              localStorage.setItem('user', JSON.stringify(user.data));
              commit('loginSuccess', user.data);
              dispatch(
                'alert/success',
                'Sie haben sich erfolgreich angemeldet.',
                { root: true }
              );
              router.push(path);
            });
        },
        (error) => {
          commit('loginFailure', error);
          dispatch('alert/error', 'E-Mail oder Passwort ungültig.', {
            root: true
          });
        }
      );
    },
    logout({ dispatch, commit }) {
      if (localStorage.getItem('user') !== null) {
        localStorage.removeItem('previewTrackingData');
        dispatch(
          'alert/success',
          'Sie haben sich erfolgreich vom System abgemeldet.',
          { root: true }
        );
      }
      userService.logout();
      commit('logout');
    }
  },
  mutations: {
    loginRequest(state, user) {
      state.status = { loggedIn: false };
      state.user = user;
    },
    loginSuccess(state, user) {
      state.status = {
        loggedIn: true,
        role: user.role,
        created: user.created,
        trainings: user.trainings
      };
    },
    loginFailure(state) {
      state.status = {};
      state.user = null;
    },
    logout(state) {
      state.status = {};
      state.user = null;
    }
  }
};



// WEBPACK FOOTER //
// ./src/_store/authentication.js